import type { OverlayScrollbarsComponentRef } from 'overlayscrollbars-react';

export const getScrollableElementFromScrollbarRef = (scrollbarRef?: OverlayScrollbarsComponentRef | null) => {
  const element = scrollbarRef?.getElement();
  if (!element) {
    return null;
  }
  return element.firstElementChild;
};

export const scrollToTop = (element?: Element | null, behavior: ScrollBehavior = 'smooth') => {
  if (!element) {
    return;
  }
  element.scrollTo({ top: 0, behavior });
};

export const scrollToBottom = (element?: Element | null, behavior: ScrollBehavior = 'smooth') => {
  if (!element) {
    return;
  }
  element.scrollTo({ top: element.getBoundingClientRect().height, behavior });
};

export const isScrollXPossible = (element?: Element | null) => {
  if (!element) {
    return false;
  }
  return (element.scrollWidth > element.clientWidth) &&
    element.matches('[data-overlayscrollbars-viewport*="overflowXScroll"]');
};

export const isScrollYPossible = (element?: Element | null) => {
  if (!element) {
    return false;
  }
  return (element.scrollHeight > element.clientHeight) &&
    element.matches('[data-overlayscrollbars-viewport*="overflowYScroll"]');
};
